import React, { useState, useEffect } from 'react';
import { Hidden, CircularProgress } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useDispatch } from 'react-redux';

import { getRequest } from 'utils/api';
import { sortToDos } from 'utils/helpers';
import { openModal } from 'features/utilsSlice';
import useIsBuyer from 'hooks/useIsBuyer';
import useIsSeller from 'hooks/useIsSeller';
import NewMilestoneDialog from 'components/milestones/NewMilestoneDialog';
import FeaturedMatches from 'components/gigs/Matches/FeaturedMatches';
import SimpleToDoCard from './SimpleToDoCard';

const progressStyle = { marginTop: 40 };

const ToDos = () => {
  const [todos, setTodos] = useState([]);
  const [completedTodos, setCompletedTodos] = useState([]);
  const [isLoading, setIsLoading] = useState({});
  const dispatch = useDispatch();
  const isBuyer = useIsBuyer();
  const isSeller = useIsSeller();

  const todosThisWeek = sortToDos(todos)
    .sort((a, b) => new Date(a.expires_at) - new Date(b.expires_at))
    .filter(todo => todo.funded && todo.sort < 10)
    .sort((a, b) => a.sort - b.sort);

  const handleUpdateTodo = todo => {
    const setTodo = prevTodos => prevTodos.filter(oldTodo => oldTodo.id !== todo.id);
    const mapTodo = prevTodos =>
      prevTodos.map(oldTodo => (oldTodo.id === todo.id ? { ...oldTodo, ...todo } : oldTodo));

    if (todo.status === 'awaiting_approval') {
      setTodos(setTodo);
      setCompletedTodos(setTodo);
    } else {
      setTodos(mapTodo);
      setCompletedTodos(mapTodo);
    }

    dispatch(openModal({ name: 'New Milestone', data: { milestone: todo } }));
  };

  useEffect(() => {
    setIsLoading(prevState => ({ ...prevState, todos: true }));

    if (isBuyer) {
      getRequest({
        endpoint: 'milestones',
        query: { status: 'awaiting_approval' },
      })
        .then(todos => {
          setTodos(todos);
          setIsLoading(prevState => ({ ...prevState, todos: false }));
        })
        .catch(() => setIsLoading(prevState => ({ ...prevState, todos: false })));
    } else {
      getRequest({
        endpoint: 'milestones',
        query: { do_this_week: true },
      })
        .then(todos => {
          setTodos(todos);
          setIsLoading(prevState => ({ ...prevState, todos: false }));
        })
        .catch(() => setIsLoading(prevState => ({ ...prevState, todos: false })));
    }
  }, [isBuyer, todos.length]);

  useEffect(() => {
    setIsLoading(prevState => ({ ...prevState, completedTodos: true }));

    getRequest({
      endpoint: 'milestones',
      query: {
        status: 'approved',
        per_page: 5,
        sort_column: 'approved_at',
        sort_direction: 'DESC',
      },
    })
      .then(todos => {
        setCompletedTodos(todos);
        setIsLoading(prevState => ({ ...prevState, completedTodos: false }));
      })
      .catch(() => setIsLoading(prevState => ({ ...prevState, completedTodos: false })));
  }, []);

  return (
    <>
      {(isLoading.todos || isLoading.completedTodos) && <CircularProgress style={progressStyle} />}

      {todos.length === 0 &&
        completedTodos.length === 0 &&
        !isLoading.todos &&
        !isLoading.completedTodos && (
          <div>
            <h4>TODOS</h4>

            <Alert severity="info">Nothing to do</Alert>
          </div>
        )}

      {todosThisWeek.length > 0 && !isLoading.todos && (
        <div>
          <h4>DO THIS WEEK</h4>

          {todosThisWeek.map(todo => (
            <SimpleToDoCard key={todo.id} todo={todo} basic />
          ))}
        </div>
      )}

      <Hidden mdUp>
        {isSeller && (
          <div style={{ margin: '15px -15px' }}>
            <FeaturedMatches />
          </div>
        )}
      </Hidden>

      {completedTodos.length > 0 && !isLoading.completedTodos && (
        <div style={todosThisWeek.length > 0 > 0 ? { marginTop: 20 } : { marginTop: 0 }}>
          <h4>RECENTLY COMPLETED (LAST 5)</h4>

          {completedTodos
            // .sort((a, b) => new Date(b.approved_at) - new Date(a.approved_at))
            .map(todo => (
              <SimpleToDoCard key={todo.id} todo={todo} basic />
            ))}
        </div>
      )}

      <NewMilestoneDialog handleUpdateMilestone={handleUpdateTodo} />
    </>
  );
};

export default ToDos;
